<script setup lang="ts">
    import Box from './Box.vue';
    import { alignItems, justifyContent, layoutBindings, spaceByBreakpoint } from './layout';
    import type { BoxProps, LayoutAlign, LayoutJustify, LayoutSpace, Responsive } from './types';

    // Box props are not declared at runtime: they fall through to Box.
    const props = defineProps<
        {
            /** Space between the children. Default `md` */
            gap?: Responsive<LayoutSpace>;
            /** Cross-axis (horizontal) alignment of the children. Default `stretch` */
            align?: LayoutAlign;
            /** Main-axis (vertical) distribution of the children. Default `start` */
            justify?: LayoutJustify;
        } & /* @vue-ignore */ BoxProps
    >();

    defineSlots<{
        default?(): unknown;
    }>();

    const bindings = computed(() =>
        layoutBindings({
            gap: spaceByBreakpoint(props.gap),
            align: alignItems(props.align),
            justify: justifyContent(props.justify),
        }),
    );
</script>

<template>
    <Box
        data-slot="stack"
        class="ui-flex ui-stack"
        v-bind="bindings"
    >
        <slot />
    </Box>
</template>

<style scoped src="./flex.css"></style>

<style scoped>
    @layer components {
        .ui-stack {
            flex-direction: column;
        }
    }
</style>
